angular.module("locations_reservations")

    .controller("LocationsReservationsListCtrl", ['LoginService', 'datasetsService', '$rootScope', '$scope', '$http', '$interval', '$q', 'i18nService', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', 'uiGridConstants', '$state',
        function (LoginService, datasetsService, $rootScope, $scope, $http, $interval, $q, i18nService, Restangular, gridService, modalService, $uibModal, $filter, $translate, uiGridConstants, $state) {
        
        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("LOCATION_RESERVATION_WRITE");

        $rootScope.title = $filter('translate')('locations_reservations.title');        
        $rootScope.breadcrumb = [
            { title: $filter('translate')('locations_reservations.title') }
        ];

        $scope.search = { location_id: null, dateFrom1: null, dateTo1: null };
        $scope.dateLocationsReservations = {};

        Restangular.all('Locations').getList().then(function (results) {
            $scope.locations = results;
        });


        $scope.statusOptions = [{
            value: 'pending', label: $filter('translate')('locations_reservations.status_pending')
        },{
            value: 'confirmed', label: $filter('translate')('locations_reservations.status_confirmed')
        },{
            value: 'cancelled', label: $filter('translate')('locations_reservations.status_cancelled')
        },{
            value: 'rejected', label: $filter('translate')('locations_reservations.status_rejected')
        }];

        $scope.gridOptionsLocationsReservations = {
            pdfTitle: $filter('translate')('locations_reservations.title'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            enableSorting: true,            
            paginationPageSizes: [20, 40, 60],
            paginationPageSize: 20,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            exporterFieldCallback: function (grid, row, col, value) {
                if (col.name == 'person_name') {
                    return row.entity.FK_locations_reservations_persons.name != null ? row.entity.FK_locations_reservations_persons.name : "" + " " +
                        row.entity.FK_locations_reservations_persons.surname != null ? row.entity.FK_locations_reservations_persons.surname : "" + " " +
                        row.entity.FK_locations_reservations_persons.lastname!= null ? row.entity.FK_locations_reservations_persons.lastname: "";
                }else{
                    if (col.name == 'status'){
                        switch(row.entity.status){
                            case 'confirmed': 
                                return $filter('translate')('locations_reservations.status_confirmed');
                                break;
                            case 'cancelled':
                                return $filter('translate')('locations_reservations.status_cancelled');
                                break;
                            case 'rejected':
                                return $filter('translate')('locations_reservations.status_rejected');
                                break;
                            case 'pending':
                                return $filter('translate')('locations_reservations.status_pending');
                                break;
                        }                        
                    }else {
                        return value
                    }
                }
            },
            columnDefs: [
              { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                { name: 'name', field: 'name', displayName: $filter('translate')('locations_reservations.name'), enableFiltering: true, enableHiding: false, width: 190 }, 
                { name: 'location_name', field: 'FK_locations_reservations_locations.name', displayName: $filter('translate')('locations_reservations.location'), enableFiltering: true, enableHiding: false, width: 200 },
              {
                  name: 'date_from', displayName: $filter('translate')('locations_reservations.date_from'), type: 'date', width: 120, cellFilter: 'date:\'dd/MM/yyyy HH:mm\'',
                  filterHeaderTemplate: '<div class="ui-grid-filter-container">' +
                                  'Desde <input ui-date="{ dateFormat: \'dd/mm/yy\' }" ng-change="grid.appScope.gridOptionsLocationsReservations.gridApi.core.raise.itemChanged(grid.appScope);" class="form-control" id="date_from1" ng-model="grid.appScope.dateFrom1" required>' +
                                  'Hasta <input ui-date="{ dateFormat: \'dd/mm/yy\' }" ng-change="grid.appScope.gridOptionsLocationsReservations.gridApi.core.raise.itemChanged(grid.appScope);" class="form-control" id="date_from2" ng-model="grid.appScope.dateFrom2" required>' +
                              '</div>',
                  enableFiltering: true, enableColumnMenu: false
              },
              {
                  name: 'date_to', displayName: $filter('translate')('locations_reservations.date_to'), type: 'date', width: 120, cellFilter: 'date:\'dd/MM/yyyy HH:mm\'',
                  filterHeaderTemplate: '<div class="ui-grid-filter-container">' +
                                  'Desde <input ui-date="{ dateFormat: \'dd/mm/yy\' }" ng-change="grid.appScope.gridOptionsLocationsReservations.gridApi.core.raise.itemChanged(grid.appScope);" class="form-control" id="date_to1" ng-model="grid.appScope.dateTo1" required>' +
                                  'Hasta <input ui-date="{ dateFormat: \'dd/mm/yy\' }" ng-change="grid.appScope.gridOptionsLocationsReservations.gridApi.core.raise.itemChanged(grid.appScope);" class="form-control" id="date_to2" ng-model="grid.appScope.dateTo2" required>' +
                              '</div>',
                  enableFiltering: true, enableColumnMenu: false
              },
              {
                  name: 'reserved_by', field:'reserved_by', displayName: $filter('translate')('locations_reservations.reserved_by'), enableFiltering: true, enableHiding: false,
                  
                },
                {
                    name: 'requested_by', displayName: $filter('translate')('locations_reservations.requested_by'), enableFiltering: true, enableHiding: false, cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.FK_locations_reservations_requested_by.name}}</div>',

                },
                {
                    name: 'total_guests', field: 'total_guests', displayName: $filter('translate')('locations_reservations.total_guests'), enableFiltering: true, enableHiding: false,width: 75,

                },
                {
                    name: 'materials', displayName: $filter('translate')('locations_reservations.recursos'), enableFiltering: true, enableHiding: false, 
                    cellTemplate:'<div><span>{{row.entity.materials}}</span></div>',
                },

              {
                  name: 'status', enableFiltering: true, filter: { selectOptions: $scope.statusOptions, type: uiGridConstants.filter.SELECT }, width: 100,
                  displayName: $filter('translate')('locations_reservations.status'), cellTemplate: '<div class="ui-grid-cell-contents" ng-if="row.entity.status == \'pending\'"><label style="display: block; padding-top: 5px; padding-bottom: 5px;" class="label label-warning">' + $filter('translate')('locations_reservations.status_pending') + '</label></div>' +
                        '<div class="ui-grid-cell-contents" ng-if="row.entity.status == \'confirmed\'"><label style="display: block; padding-top: 5px; padding-bottom: 5px;" class="label label-primary">' + $filter('translate')('locations_reservations.status_confirmed') + '</label></div>' +
                        '<div class="ui-grid-cell-contents" ng-if="row.entity.status == \'cancelled\'"><label style="display: block; padding-top: 5px; padding-bottom: 5px;" class="label label-danger">' + $filter('translate')('locations_reservations.status_cancelled') + '</label></div>' +
                        '<div class="ui-grid-cell-contents" ng-if="row.entity.status == \'rejected\'"><label style="display: block; padding-top: 5px; padding-bottom: 5px;" class="label label-danger">' + $filter('translate')('locations_reservations.status_rejected') + '</label></div>',
                  enableColumnMenu: false,                  
              },
              {
                  name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                      { title: $filter('translate')('locations_reservations.button_edit'), action: 'ui-sref="locations_reservations.edit({id:row.entity.id})" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-edit" },
                      { title: $filter('translate')('locations_reservations.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.FK_locations_reservations_locations.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                  ], { cssClass: "pull-right" })
              },
            ],
            getData: function (options) {
                options.location_id = $scope.search.location_id;
                options.dateFrom1 = $scope.search.date_from;
                options.dateTo2 = $scope.search.date_to;

                return Restangular.all('LocationsReservations').getList(options)                        
            }
        };

        $scope.loadData = function () {
            $scope.gridOptionsLocationsReservations.loadData(false);
        }

        $scope.clearForm = function () {
            $scope.search = { location_id: null, date_from: null, date_to: null };
            $scope.gridOptionsLocationsReservations.loadData(false);
        }

        $scope.goToEdit = function (rowEntity) {
            $state.go("locations_reservations.edit", { id: rowEntity.id });
        }

        $scope.deleteDialog = function (id, location_name) {
            $scope.id = id;
            $scope.location_name = location_name;            
            modalService.confirm({
                title: $filter('translate')('locations_reservations.button_delete'),
                message: $filter('translate')('locations_reservations.delete_message') + " " + $scope.location_name + "?",
                onAccept: function () {
                    Restangular.one('LocationsReservations', $scope.id).remove().then(function () {
                        toastr.success($filter('translate')('locations_reservations.delete_success'));
                        $scope.gridOptionsLocationsReservations.gridApi.core.raise.itemDeleted($scope);                        
                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });
        };


        $scope.export = function () {
            var options = {
                filters: {
                    EXPORT_TYPE: "LOCATION",
                    LOCATION: $scope.search.location_id,
                    DATE_FROM: $scope.search.date_from,
                    DATE_TO: $scope.search.date_to
                }
            };

            datasetsService.exportByType("reservation", options);
        };

        
    }])

;